export const PROVIDER_GEOLOC_NOT_CONFIGURED =
  'The provider does not have geolocation configured';
